<script>

    import Image from "./Image.svelte";
    import {optionsStore} from "../core/app-store.js";
    import {createEventDispatcher, onMount} from "svelte";
    import NutritionalBar from "./NutritionalBar.svelte";
    import Price from "./Price.svelte";
    const dispatch = createEventDispatcher();

    export let record;
    export let publishConfig;
    export let tenantKey;
    export let cardHeight;

    let nutritionalOpen = false;

    let media = (record?.media || []).length > 0 ? record?.media[0] : undefined;

    onMount(() => {
        if (record?.media?.length > 1 && record?.media[0]?.type === 'video') {
            for (let i = 1; i < record.media.length; i++) {
                if (record.media[i].type === 'photo') {
                    media = record.media[i];
                    break;
                }
            }
        }
    });

    const toggleDetailsScreen = (record) => {
        dispatch('toggleDetailsScreen', record);
    }

</script>
<style>

    .card {
        flex: 1 1 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        gap: 6px;
    }
    .card .media-block {
        position: relative;
        height: 200px;
    }
    .card .media-block .label {
        position: absolute;
        top: 10px;
        left: 10px;
        text-transform: uppercase;
        font-family: PT Mono, sans-serif;
        font-size: 12px;
        letter-spacing: 1.2px;
        border-radius: 2rem;
        opacity: .9;
        line-height: 1;
        background: var(--bg-second-color);
        color: var(--accent-color);
        overflow: hidden;
        padding: 5px 8px 4px 8px;
    }
    .description {
        color: var(--secondary-font-color);
        line-height: 120%;
        font-family: Roboto, sans-serif;
        font-size: 16px;
    }

    @media (min-width: 768px) {
        .card .media-block {
            height: 270px;
        }
    }
</style>

<div class="card desktop-col-3 user-select-none pointer" on:click={() => toggleDetailsScreen(record)}>

    <div class="media-block">
        {#if (record?.media?.length > 0)}
            <Image src={media?.name}
                   tenantKey={media?.ref || tenantKey}
                   hasVideo={ (record.media || []).find(x => x.type === 'video') !== undefined }
                   scaleOnHover={true}
                   imgHeight="{cardHeight}"
                   alt={record?.name || ''}>
            </Image>
        {:else }
            <Image imgHeight="{cardHeight}"
                   alt={record?.name || ''}>
            </Image>
        {/if}

        {#if (record.label !== null && record.label !== undefined)}
            <span class="label">
                { record.label }
            </span>
        {/if}
    </div>

    <div class="flex-between ___ai-center gap-05">
        <h4 class="record-name" on:click={() => {nutritionalOpen = !nutritionalOpen;}}>
            {record.name || ''}
        </h4>
        <div>
            <Price record={record}
                   priceItem={record.prices[0]}
                   publishConfig={publishConfig}
                   on:add={(e) => dispatch('addToCart', e.detail)}
                   on:remove={(e) => dispatch('removeFromCart', e.detail)}
            >
            </Price>
        </div>
    </div>

    {#if (record.description) }
        <div class="description">
            { record.description }
        </div>
    {/if}

    {#if (record._found_desc && record.promoted?.enabled === true)}
        <div class="found_description fs-90 lh-110 flex-fill">
            {@html record._found_desc }
        </div>
    {/if}

    <NutritionalBar record={record}
                    open={nutritionalOpen}>
    </NutritionalBar>

</div>
